import React from 'react'
import PropTypes from 'prop-types'
import { Form, InputGroup } from 'react-bootstrap'
import * as styles from '../FieldGroup/_FieldGroup.scss'

const inputGroupAddonStyles = styles['ag-input-group-addon']
const prefixStyles = inputGroupAddonStyles + ' ' + styles['prefix']

const FieldGroupTextArea = ({
  id,
  label,
  help,
  message,
  isInvalid,
  handleChange,
  required,
  value,
  prefix,
  fieldGroupClass,
  suffix,
  onFocus,
  onBlur,
  rows = 4,
  ...remainingProps
}) => {
  let inputSpan = null

  return (
    <Form.Group className={[styles['field-group-spacing'], fieldGroupClass].filter(Boolean).join(' ')} controlId={id}>
      {label && label.length > 0 ? (
        <Form.Label className={[required ? styles['required'] : null, styles['form-label']].filter(Boolean).join(' ')}>
          {label}
        </Form.Label>
      ) : null}
      <InputGroup style={{ width: '100%' }}>
        <span ref={(span) => { inputSpan = span }} className={styles['ag-input-group']}>
          {prefix && <InputGroup.Text className={prefixStyles}>{prefix}</InputGroup.Text>}
          <Form.Control
            as="textarea"
            rows={rows}
            className={styles['ag-input-box']}
            value={value}
            isInvalid={isInvalid}
            onChange={(event) => {
              handleChange(event.target.value, event.target)
            }}
            onFocus={(e) => {
              inputSpan.className += (' ' + styles['input-focussed'])
              if (onFocus) onFocus(e)
            }}
            onBlur={(e) => {
              inputSpan.className = inputSpan.className.replace(styles['input-focussed'], '')
              if (onBlur) onBlur(e)
            }}
            {...remainingProps}
          />
        </span>
        {suffix && <InputGroup.Text className={inputGroupAddonStyles}>{suffix}</InputGroup.Text>}
      </InputGroup>
      {(help || message) && <Form.Text className={styles['help-block-font-size']}>{help || message}</Form.Text>}
    </Form.Group>
  )
}

FieldGroupTextArea.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  help: PropTypes.string,
  message: PropTypes.string,
  isInvalid: PropTypes.bool,
  handleChange: PropTypes.func,
  required: PropTypes.bool,
  fieldGroupClass: PropTypes.string,
  suffix: PropTypes.node,
  prefix: PropTypes.string,
  value: PropTypes.string.isRequired,
  rows: PropTypes.number
}

export default FieldGroupTextArea
